/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type AdvancedSettingsV5_organization$ref = any;
type Amendments_organization$ref = any;
type RulesSections_organization$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type ModularGrid_organization$ref: FragmentReference;
declare export opaque type ModularGrid_organization$fragmentType: ModularGrid_organization$ref;
export type ModularGrid_organization = {|
  +id: string,
  +constitutionLabel: string,
  +viewerIsAdmin: boolean,
  +onRestrictedPlan: boolean,
  +viewer: {|
    +routes: {|
      +constitutionUrl: string
    |}
  |},
  +$fragmentRefs: RulesSections_organization$ref & AdvancedSettingsV5_organization$ref & Amendments_organization$ref,
  +$refType: ModularGrid_organization$ref,
|};
export type ModularGrid_organization$data = ModularGrid_organization;
export type ModularGrid_organization$key = {
  +$data?: ModularGrid_organization$data,
  +$fragmentRefs: ModularGrid_organization$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ModularGrid_organization",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "constitutionLabel",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerIsAdmin",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "onRestrictedPlan",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Person",
      "kind": "LinkedField",
      "name": "viewer",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Routes",
          "kind": "LinkedField",
          "name": "routes",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "constitutionUrl",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RulesSections_organization"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AdvancedSettingsV5_organization"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Amendments_organization"
    }
  ],
  "type": "Organization",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = 'fff716a9bb86d78a178c11bd7674be64';

module.exports = node;
